const SemVer = require('../classes/semver')
const major = (a, loose) => new SemVer(a, loose).major
module.exports = major



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonwebtoken/node_modules/semver/functions/major.js
// module id = 1462
// module chunks = 29